export default __webpack_public_path__ + "static/media/smabout.36f9ef9c.jpg";